import {
  GET_ACTIVE_CUSOMTER_ORDERS,
  GET_ACTIVE_CUSTOMER,
} from "../../graphql/queries/customer"

import { ResultOf, VariablesOf } from "@/graphql/gql-tada"
import { authenticatedRequest } from "@/lib/auth"

export const fetchActiveCustomer = async () => {
  const { activeCustomer } = await authenticatedRequest(GET_ACTIVE_CUSTOMER)

  return activeCustomer
}

export type CustomerOrdersVariables = VariablesOf<
  typeof GET_ACTIVE_CUSOMTER_ORDERS
>
export type CustomerOrdersResult = ResultOf<typeof GET_ACTIVE_CUSOMTER_ORDERS>

export const fetchCustomerOrders = async (
  variables: CustomerOrdersVariables,
) => {
  return await authenticatedRequest(GET_ACTIVE_CUSOMTER_ORDERS, variables)
}
